import { NAVY } from '../../utils/constants';

// One rolling-subtraction block: Line | Amount | Running. Rows come from
// buildRevenueBlocks. Start and result rows are emphasised; deduction lines
// are muted so the running column reads as the primary figure.
const fmt = (n) => `₹${Math.round(n || 0).toLocaleString('en-IN')}`;

const th = { padding: '8px 12px', fontWeight: 700, fontSize: 'var(--text-xs)', color: 'var(--color-ink-muted)', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', whiteSpace: 'nowrap', background: 'var(--color-sunken)', borderBottom: '1px solid var(--color-border-strong)' };
const thNum = { ...th, textAlign: 'right' };
const td = { padding: '7px 12px', fontSize: 'var(--text-sm)', color: 'var(--color-ink-brand-softer)', borderBottom: '1px solid var(--color-border-subtle)', verticalAlign: 'middle' };
const tdNum = { ...td, textAlign: 'right', fontVariantNumeric: 'tabular-nums' };

export default function RevenueBlockTable({ title, rows, resultTone = '#166534' }) {
  return (
    <div>
      {title && (
        <div style={{ fontSize: '0.68rem', fontWeight: 700, color: 'var(--color-ink-faint)', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 8 }}>{title}</div>
      )}
      <div style={{ overflowX: 'auto', borderRadius: 'var(--radius-lg)', border: '1px solid var(--color-border)', marginBottom: 10 }}>
        <table className="data-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: 'var(--text-sm)' }}>
          <thead>
            <tr>
              <th style={th}>Line</th>
              <th style={thNum}>Amount</th>
              <th style={thNum}>Running</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => {
              const isStart = row.kind === 'start';
              const isResult = row.kind === 'result';
              const emphasis = isStart || isResult;
              const rowStyle = isResult
                ? { background: 'var(--color-sunken)' }
                : undefined;
              const labelStyle = { ...td, fontWeight: emphasis ? 700 : 500, color: emphasis ? NAVY : 'var(--color-ink-brand-softer)', borderTop: isResult ? '1px solid var(--color-border-strong)' : undefined, paddingLeft: row.kind === 'line' ? 24 : 12 };
              const amountStyle = { ...tdNum, fontWeight: emphasis ? 700 : 500, color: isResult ? resultTone : row.sign === '−' ? '#b45309' : row.sign === '+' ? '#166534' : NAVY, borderTop: isResult ? '1px solid var(--color-border-strong)' : undefined };
              const runningStyle = { ...tdNum, fontWeight: 700, color: isResult ? resultTone : NAVY, borderTop: isResult ? '1px solid var(--color-border-strong)' : undefined, fontSize: isResult ? '0.95rem' : undefined };
              return (
                <tr key={i} style={rowStyle}>
                  <td style={labelStyle}>{row.sign ? `${row.sign} ${row.label}` : row.label}</td>
                  <td style={amountStyle}>{row.kind === 'line' ? `${row.sign}${fmt(row.amount)}` : fmt(row.amount)}</td>
                  <td style={runningStyle}>{isStart ? '' : fmt(row.running)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
